import { useState, useEffect } from "react";

const STORAGE_KEY = "campaign_participation_guide_shown";

export const useParticipationGuide = () => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // 로컬스토리지에서 확인 여부 체크
    const hasShown = localStorage.getItem(STORAGE_KEY);
    if (!hasShown) {
      setShouldShow(true);
    }
  }, []);

  const markAsShown = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setShouldShow(false);
  };

  return {
    shouldShow,
    markAsShown,
  };
};
